import { type FC } from 'react';

import { ListingLayout } from '../ListingLayout';
import { SkeletonRect } from '../SkeletonRect';

import styles from './ListingLoadingView.css';

interface IListingLoadingViewProps {
  isNarrow: boolean;
}

export const ListingLoadingView: FC<IListingLoadingViewProps> = ({ isNarrow }) => {
  return (
    <ListingLayout
      isFetching
      cards={null}
      isNarrow={isNarrow}
      navigation={<SkeletonRect height={20} width="50%" />}
      noCardsDump={null}
      pagination={null}
      seo={
        <div className={styles['seo']}>
          <SkeletonRect height={36} />
          <SkeletonRect height={36} />
        </div>
      }
      similarCards={null}
    />
  );
};
